import { getConfig } from './config'

/**
 * @description End point for Quiz
 */
export const QUIZ_ENDPOINT = '/quiz'

/**
 * @description Prefix End point for Login
 */
export const CANDIDATE_ENDPOINT = '/candidate'
/**
 * @description End point for Login
 */
export const LOGIN_ENDPOINT = '/login'
/**
 * @description End point for Username
 */
export const USER_ENDPOINT = '/user'
/**
 * @description End point for Compile
 */
export const COMPILE_ENDPOINT = '/code-run'
/**
 * @description End point for proctoring
 */
export const PROCTORING_ENDPOINT = '/credential-exchange'
/**
 * @description Client ID for GAuth
 */
export const getClientID = () => getConfig().googleClientId

/**
 * @description Client ID for MAuth
 */
export const getAzureClientID = () => getConfig().azureClientId
export const getAzureTenantID = () => getConfig().azureTenantId
/**
 * @description base URL for mock server
 */
export const getBaseUrl = () => getConfig().baseUrl
/**
 * @description Admin URL for Redirecting from landing page
 */

export const getAdminUrl = () => getConfig().adminUrl

/**
 * @description Faro App Name for monitoring and logs
 */
export const getFaroAppName = () => getConfig().faroAppName || ''

/**
 * @description Faro url for monitoring and logs
 */
export const getFaroAppURL = () => getConfig().faroUrl || ''

/**
 *  @description Faro api key for authentication
 */
export const getFaroAPIKey = () => getConfig().faroApiKey || ''

/**
 * @description Bugsnag key for monitoring run time errors
 */
export const getBugsnagKey = () => getConfig().bugsnagKey || ''
/**
 * @description End point for proctoring
 */
export const REFRESH_TOKEN_URL = '/refresh'
